import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MyDpDateService } from '../../services/my-dp-date.service';

@Component({
  selector: 'app-list-filters',
  templateUrl: './list-filters.component.html',
  styleUrls: ['./list-filters.component.css'],
})
export class ListFiltersComponent implements OnInit, OnDestroy {
  @Input() dateFields: string[];
  @Input() form: FormGroup;
  @Input() hideAutoLimit: boolean;
  @Input() loading: boolean;
  @Output() refresh = new EventEmitter<any>();
  defaultLimit: number;
  private onDestroy$: Subject<void> = new Subject();

  constructor(private fb: FormBuilder, private dpService: MyDpDateService) {}

  ngOnInit(): void {
    if (this.dateFields) {
      this.form.registerControl('dateFrom', this.fb.control(''));
      this.form.registerControl('dateTo', this.fb.control(''));
      this.form.registerControl(
        'dateField',
        this.fb.control(this.dateFields[0]),
      );

      if (this.dateFields.length === 1) {
        this.form.controls.dateField.disable();
      }
    }

    this.form.registerControl('filters', this.fb.control({}));

    this.defaultLimit = this.form.controls.limit.value;

    this.form.controls.limit.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((l) => {
        // this.limit.setValue(l);
        this.form.markAsPristine();
        this.onRefresh();
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onRefresh(force = false): void {
    const filters = this.form.getRawValue();
    delete filters.limit;

    if (this.form.controls.dateField) {
      const dateF = this.form.controls.dateField.value;

      const dateFrom = filters.dateFrom
        ? moment
            .utc(this.dpService.parse(filters.dateFrom, 'date'))
            .startOf('day')
            .format()
        : false;

      const dateTo = filters.dateTo
        ? moment
            .utc(this.dpService.parse(filters.dateTo, 'date'))
            .endOf('day')
            .format()
        : false;

      if (dateFrom) {
        if (dateTo) {
          filters[dateF] = {
            between: [dateFrom, dateTo],
          };
        } else {
          filters[dateF] = { gt: dateFrom };
        }
      } else if (dateTo) {
        filters[dateF] = { lt: dateTo };
      }
    }

    delete filters.dateField;
    delete filters.dateFrom;
    delete filters.dateTo;
    delete filters.filters;
    this.form.controls.filters.setValue(filters);

    this.refresh.emit(force);
  }

  onReset(): void {
    this.form.reset(
      { dateField: this.dateFields[0], limit: this.defaultLimit },
      { emitEvent: false },
    );
    this.onRefresh();
  }
}
